window.CKB_SEARCH_INDEX = (window.CKB_SEARCH_INDEX || []).concat([
  {
    "id": "CKC-KA-1407",
    "title": "2021 Army QRPX: Chameleon Antenna Field Report",
    "handle": "2021-army-qrpx-chameleon-antenna-field-report",
    "quick": "The Fort Irwin Operations Group station won the 2021 Army HF Low-Power Competition military category with 86 points while using a diverse antenna field that included six Chameleon-supplied evaluation systems and an operator-owned MPAS 2.0.",
    "summary": "A source-governed account of the 2021 Army NETCOM QRPX station, scoring result, desert operating conditions, antenna roles, limitations, and independent disclosure.",
    "category": "Field Reports & Independent Reviews",
    "section": "2021 Army QRPX",
    "keywords": "Army NETCOM QRPX 2021 Fort Irwin Operations Group Q54 86 points low power HF 20 watts military field report Chameleon SKYLOOP 2.0 TD 2.0 Tactical Dipole EMCOMM III Portable LEFS TDL Tactical Delta Loop RXL MPAS 2.0 Mojave Desert wind sand ALE 3G TacChat",
    "seoTitle": "2021 Army QRPX Chameleon Antenna Field Report | CKB",
    "metaDescription": "Read the complete source-governed field report from the Fort Irwin team that won the 2021 Army HF low-power competition military category.",
    "difficulty": "All operators",
    "readingTime": "12–15 min",
    "revision": "1.0",
    "reviewed": "2026-07-22",
    "url": "/pages/chameleon-knowledge-base?article=2021-army-qrpx-chameleon-antenna-field-report",
    "published": true,
    "canonicalHandle": "2021-army-qrpx-chameleon-antenna-field-report",
    "canonicalId": "CKC-KA-1407",
    "editorialStatus": "source_governed",
    "bodyChunk": "29",
    "relatedHeadings": ["Competition Context", "Verified Outcome", "Antenna Field", "Product-by-Product Findings", "Operating Conditions and Limits", "Source Disclosure", "Field Gallery", "Original Report"],
    "sourceReviewed": "2026-07-22",
    "sourceAuthority": "CW2 Anthony M. Jaber's 2021 CC BY-SA field report and the supplied 2021 military score sheet",
    "freshnessPolicy": "Historical record. Recheck only if the source file, attribution, publication permission, product identity, or contextual interpretation changes. Current product documentation controls present specifications."
  },
  {
    "id": "CKC-KA-1408",
    "title": "CHA MPAS 2.0: QST July 2023 Independent Review",
    "handle": "cha-mpas-2-0-qst-july-2023-independent-review",
    "quick": "John Leonardelli, VE3IPS, reviewed the CHA MPAS 2.0 as a configurable field go-kit for portable, POTA, Field Day, emergency, NVIS, vehicle-supported, manpack, and balcony operation.",
    "summary": "An attributed guide to the authorized July 2023 QST MPAS 2.0 reprint, including the review context, main observations, limitations, and present-document boundary.",
    "category": "Field Reports & Independent Reviews",
    "section": "CHA MPAS 2.0",
    "keywords": "CHA MPAS 2.0 QST July 2023 John Leonardelli VE3IPS authorized ARRL reprint review portable POTA SOTA Field Day emergency communications NVIS manpack balcony vehicle tripod rugged grab and go",
    "seoTitle": "CHA MPAS 2.0 QST July 2023 Review | CKB",
    "metaDescription": "Read the source-governed guide and authorized QST reprint for John Leonardelli's July 2023 CHA MPAS 2.0 review.",
    "difficulty": "All operators",
    "readingTime": "5–7 min",
    "revision": "1.0",
    "reviewed": "2026-07-22",
    "url": "/pages/chameleon-knowledge-base?article=cha-mpas-2-0-qst-july-2023-independent-review",
    "published": true,
    "canonicalHandle": "cha-mpas-2-0-qst-july-2023-independent-review",
    "canonicalId": "CKC-KA-1408",
    "editorialStatus": "source_governed",
    "bodyChunk": "29",
    "relatedHeadings": ["Review Context", "What the Reviewer Found", "Limitations and Current-Document Boundary", "Authorized Reprint"],
    "sourceReviewed": "2026-07-22",
    "sourceAuthority": "Authorized QST reprint, July 2023, by John Leonardelli, VE3IPS",
    "freshnessPolicy": "Historical editorial record. Current Chameleon product documentation controls present specifications, contents, ratings, and supported configurations."
  },
  {
    "id": "CKC-KA-1409",
    "title": "CHA MPAS 2.0: CQ Magazine March 2022 Independent Review",
    "handle": "cha-mpas-2-0-cq-march-2022-independent-review",
    "quick": "Martin Lubbe, ZS1ML, evaluated the CHA MPAS 2.0 for CQ Magazine, focusing on component quality, portable configurations, rapid setup, measured SWR examples, and tuner-supported field use.",
    "summary": "An attributed summary of the March 2022 CQ Magazine review without redistributing the full article, because documented CQ reprint permission is not present.",
    "category": "Field Reports & Independent Reviews",
    "section": "CHA MPAS 2.0",
    "keywords": "CHA MPAS 2.0 CQ Magazine March 2022 Martin Lubbe ZS1ML independent review portable vertical manpack inverted L sloper inverted V NVIS loop NanoVNA tuner build quality",
    "seoTitle": "CHA MPAS 2.0 CQ Magazine March 2022 Review | CKB",
    "metaDescription": "Read an attributed, source-governed summary of Martin Lubbe's March 2022 CQ Magazine review of the CHA MPAS 2.0.",
    "difficulty": "All operators",
    "readingTime": "4–6 min",
    "revision": "1.0",
    "reviewed": "2026-07-22",
    "url": "/pages/chameleon-knowledge-base?article=cha-mpas-2-0-cq-march-2022-independent-review",
    "published": true,
    "canonicalHandle": "cha-mpas-2-0-cq-march-2022-independent-review",
    "canonicalId": "CKC-KA-1409",
    "editorialStatus": "source_governed",
    "bodyChunk": "29",
    "relatedHeadings": ["Review Context", "What the Reviewer Found", "Limitations and Current-Document Boundary", "Publication and Permission Note"],
    "sourceReviewed": "2026-07-22",
    "sourceAuthority": "CQ Magazine, March 2022, review by Martin Lubbe, ZS1ML",
    "freshnessPolicy": "Historical editorial record. Current Chameleon product documentation controls present specifications, contents, ratings, and supported configurations."
  }
]);
